<template>
  <Modal
    title="Quote Changes"
    modal-classes="modal-xl modal-top"
    :show-save="false"
    @close="$emit('close')"
  >
    <div v-if="isLoading" class="py-4 text-center text-muted">
      Loading revision details...
    </div>
    <div v-else-if="revision === null" class="py-4 text-center text-muted">
      No revision details found.
    </div>
    <template v-else>
      <div class="row g-3 mb-4">
        <div class="col-md-6">
          <div class="fs-sm text-muted">
            <strong>Revision:</strong>
            #{{ revision.revision_number }}
            <br />
            <strong>Summary:</strong>
            {{ revision.summary }}
            <br />
            <strong>Changed By:</strong>
            {{ revision.changed_by }}
          </div>
        </div>
        <div class="col-md-6">
          <div class="fs-sm text-muted">
            <strong>When:</strong>
            {{ revision.created_at_display }}
          </div>
        </div>
      </div>

      <table class="table table-striped table-sm table-bordered table-hover">
        <thead class="text-center">
          <tr>
            <th style="width: 18%">Area</th>
            <th style="width: 22%">Item</th>
            <th style="width: 30%">Before</th>
            <th style="width: 30%">After</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="change in revision.changes" :key="change.id">
            <td>
              <div class="fw-semibold">{{ change.model }}</div>
              <div class="fs-xs text-muted">
                {{ change.event }}
              </div>
            </td>
            <td>
              <div class="fw-semibold">{{ change.field }}</div>
              <div class="fs-xs text-muted">
                {{ change.subject }}
              </div>
            </td>
            <td class="align-top">
              <pre
                v-if="change.before_is_complex"
                class="mb-0 small history-json"
              ><code>{{ formatComplex(change.before) }}</code></pre>
              <span v-else>
                {{ formatScalar(change.before) }}
              </span>
            </td>
            <td class="align-top">
              <pre
                v-if="change.after_is_complex"
                class="mb-0 small history-json"
              ><code>{{ formatComplex(change.after) }}</code></pre>
              <span v-else>{{ formatScalar(change.after) }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </Modal>
</template>

<script setup>
import Modal from "@/components/modal.vue";

defineProps({
  revision: {
    type: Object,
    default: null,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["close"]);

function formatScalar(value) {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }

  return value;
}

function formatComplex(value) {
  if (value === null || value === undefined) {
    return "-";
  }

  return JSON.stringify(value, null, 2);
}
</script>

<style scoped>
.history-json {
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
